import UaParser from 'ua-parser-js'
import { isUnityUA } from '@/packages/plugins/appUAConfig'

const uaParser = new UaParser()
const ua = navigator.userAgent || ''

// 应用内部
export const isAPP = isUnityUA(ua)

// 判断设备类型
export const isAndroid = uaParser.getResult().os.name === 'Android' || /Android/i.test(ua)
export const isiOS = () => {
  if (uaParser.getResult().os.name === 'iOS' || isIpad() || /iphone|ipad|ipod|iOS/i.test(ua)) {
    return true
  } else if (window.webkit) {
    return true
  }
  return false
}

/** 判断是否Touch屏幕 */
const isTouchScreen = () => {
  return 'ontouchstart' in window || (window.DocumentTouch && document instanceof window.DocumentTouch)
}

/** 判断是否为ipad */
export const isIpad = () => {
  const platform = window.navigator.platform
  const uaInfo = window.navigator.userAgent
  const macos = platform === 'MacIntel'
  const screenWidth = screen.width
  const screenHeight = screen.height
  if (uaInfo.match(/(iPad).*OS\s([\d_]+)/)) {
    return true
  }
  if (
    macos &&
    isTouchScreen() &&
    ((screenWidth === 1024 && screenHeight === 1366) || // Pro 12.9
      (screenWidth === 834 && screenHeight === 1194) || // Pro 11
      (screenWidth === 834 && screenHeight === 1112) || // Pro 10.5
      (screenWidth === 768 && screenHeight === 1024)) // other
  ) {
    return uaInfo.match(/(Version)\/([\d.]+)/)
  }
}
